<template>
  <div class="d-flex flex-column justify-space-between" style="height: 100%; ">
    <div>
      <p class="caption lightgray--text">Thiết Lập Khóa Học & Môn Học</p>
      <department-form :student="student" ref="form" md-6 />
    </div>
    <div class="d-flex justify-space-between">
      <v-btn @click="$emit('back')" depressed small>Quay Lại</v-btn>
      <v-spacer />
      <v-btn color="primary" @click="save()" :disabled="!student.id" :loading="loading" depressed small>Tiếp Tục</v-btn>
    </div>
  </div>
</template>
<script>
import DepartmentForm from '@/components/basic/form/StudentDepartmentForm.vue'
import { Student } from '@/plugins/api'
export default {
  components: { DepartmentForm },
  props: {
    student: Object
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    async save () {
      if (this.validate()) {
        this.loading = true
        await Student.update(this.student.id, { ...this.getData })
        this.$alert.success('Cập nhật thông tin thành công')
        this.$emit('update:student', { ...this.student, ...this.getData() })
        this.$emit('complete')
        this.loading = false
      }
    },
    validate () {
      return this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      return this.$refs.form.resetValidation()
    },
    getData () {
      return this.$refs.form.getData()
    }
  },
  computed: {},
  filters: {},
  watch: {
    student () {
      this.resetValidation()
    }
  }
}
</script>
<style scoped>
.bottom {
  align-self: flex-end;
}
</style>
